import { useEffect, useRef, useState } from 'react'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { sleep } from 'src/mentor/helpers/utilityFunctions'
import { DosagePillItem } from '../drugAdvice/components/styledComponents'
import PrescriptionPillOptionsInputComponent from './PrescriptionPillOptionsInputComponent'

export default function PillInputComponent({
  value,
  handleChange,
  options,
  getOptionValue,
  getOptionLabel,
  valueKey,
  pillUnselectedBackground,
}) {
  const otherOptionNotSelected = options.map((dos) => getOptionValue(dos))?.includes(value)
  const customInputRef = useRef()

  // Local state for the "Other" free-text input — immediate display, debounced parent update
  const isOtherValue = !otherOptionNotSelected
  const [otherLocal, setOtherLocal] = useState(isOtherValue ? (value || '') : '')
  const _otherTimerRef = useRef(null)
  const _handleChangeRef = useRef(handleChange)
  _handleChangeRef.current = handleChange

  // Sync local state when canonical value changes (e.g., form opened with existing "other" text)
  useEffect(() => {
    if (!options.map((dos) => getOptionValue(dos))?.includes(value)) {
      setOtherLocal(value || '')
    } else {
      setOtherLocal('')
    }
  }, [value]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => () => clearTimeout(_otherTimerRef.current), [])

  async function handleOtherPillClick() {
    clearTimeout(_otherTimerRef.current)
    setOtherLocal('')
    handleChange({ target: { value: '', id: valueKey } })
    await sleep(300)
    customInputRef.current.focus()
  }

  return (
    <div>
      <PrescriptionPillOptionsInputComponent
        options={options}
        onChange={(newValue) => {
          // Predefined pill selected — cancel any pending "Other" text debounce immediately
          clearTimeout(_otherTimerRef.current)
          setOtherLocal('')
          handleChange({ target: { value: getOptionValue(newValue), id: valueKey } })
        }}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        value={value}
        pillUnselectedBackground={pillUnselectedBackground}
      ></PrescriptionPillOptionsInputComponent>
      <div className="d-flex align-items-center gap-1 mt-1">
        <DosagePillItem selected={!otherOptionNotSelected} onClick={handleOtherPillClick}>
          Other
        </DosagePillItem>
        {!otherOptionNotSelected && (
          <div style={{ maxWidth: '100%' }}>
            <CustomInput
              inputRef={customInputRef}
              value={otherLocal}
              onChange={(e) => {
                const val = e.target.value
                setOtherLocal(val)
                clearTimeout(_otherTimerRef.current)
                _otherTimerRef.current = setTimeout(() => {
                  _handleChangeRef.current({ target: { value: val, id: valueKey } })
                }, 300)
              }}
              id={valueKey}
            />
          </div>
        )}
      </div>
    </div>
  )
}

// inputAnsMessageContainerStyles={{
//   background: '#ebebeb',
// }}
// pureInputProps={{
//   style: {
//     color:
//       options.map((dos) => getOptionValue(dos))?.includes(value) || value === ''
//         ? '#000'
//         : '#fff',
//   },
// }}
